import { BellOff, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useThemeColors } from '../context/ThemeContext';
import { dsv2, dsv2Light } from '../styles/designSystemV2';
import { zLayer } from '../styles/zIndex';

/**
 * Modal con los pasos para reactivar las notificaciones cuando el navegador
 * las tiene BLOQUEADAS (permiso 'denied'). En ese estado el navegador ya no
 * vuelve a mostrar su popup, así que el cliente debe desbloquearlas a mano.
 * Se muestran pasos distintos para móvil y escritorio.
 */
export default function PushBlockedModal({ open, onClose }) {
  const { t } = useTranslation();
  const { isDark } = useThemeColors();
  const T = isDark ? dsv2 : dsv2Light;

  if (!open) return null;

  const isMobile = typeof window !== 'undefined'
    && window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  const variant = isMobile ? 'Mobile' : 'Desktop';
  const steps = [
    t(`push.blocked${variant}1`),
    t(`push.blocked${variant}2`),
    t(`push.blocked${variant}3`),
  ];

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: zLayer.blockingModal,
        backgroundColor: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: T.surface, border: `1px solid ${T.outline}`,
          borderRadius: T.radius.xl, padding: '24px', maxWidth: '420px', width: '100%',
          boxShadow: T.shadow.lg,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '8px' }}>
          <div style={{
            width: '40px', height: '40px', borderRadius: '50%', flexShrink: 0,
            backgroundColor: T.red, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <BellOff size={20} color="white" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '17px', fontWeight: '700', color: T.text }}>
              {t('push.blockedTitle')}
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label={t('push.blockedGotIt')}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: T.textMuted, padding: 0 }}
          >
            <X size={20} />
          </button>
        </div>

        <p style={{ fontSize: '14px', color: T.textMuted, margin: '0 0 16px', lineHeight: 1.5 }}>
          {t('push.blockedIntro')}
        </p>

        <ol style={{ margin: '0 0 20px', padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {steps.map((step, i) => (
            <li key={i} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
              <div style={{
                width: '24px', height: '24px', borderRadius: '50%', flexShrink: 0,
                backgroundColor: T.surfaceLow, color: T.text,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '13px', fontWeight: '700',
              }}>
                {i + 1}
              </div>
              <span style={{ fontSize: '14px', color: T.text, lineHeight: 1.5, paddingTop: '1px' }}>
                {step}
              </span>
            </li>
          ))}
        </ol>

        <button
          onClick={onClose}
          style={{
            width: '100%', padding: '12px', backgroundColor: T.red, color: 'white', border: 'none',
            borderRadius: T.radius.md, fontWeight: '700', fontSize: '15px', cursor: 'pointer',
          }}
        >
          {t('push.blockedGotIt')}
        </button>
      </div>
    </div>
  );
}
